import { render, staticRenderFns } from "./StudyNewPageCommonHeader.vue?vue&type=template&id=b92d82ba&scoped=true"
import script from "./StudyNewPageCommonHeader.vue?vue&type=script&lang=js"
export * from "./StudyNewPageCommonHeader.vue?vue&type=script&lang=js"
import style0 from "./StudyNewPageCommonHeader.vue?vue&type=style&index=0&id=b92d82ba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b92d82ba",
  null
  
)

export default component.exports